<div class="col-lg-12 row">
    <div class="col-lg-12 ml-2 data-sect">
        <div class="col-lg-12">
            <h3>Banner List</h3>
        </div>
        <hr>
        <table
            class="table"
            [svData]="data"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="data && data.length > 0"
        >
            <thead>
                <tr>
                    <th>{{selection === 'Banners for Product' ? 'Scheme': 'File Name'}}</th>
                    <ng-template [ngIf]="selection === 'Banners for CEO'">
                        <th>URL</th>
                    </ng-template>
                    <th class="text-center">Last Updated On</th>
                    <th
                        class="text-center"
                        width="10%"
                    >
                        View
                    </th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                <ng-template [ngIf]="item.schemeName !== null">
                    <td
                        *ngIf="item.bannerType === 'Banners for Product'"
                        [display]="item.schemeName"
                        [tooltip]="item.schemeName"
                        placement="top"
                        show-delay="300"
                    >
                        {{ item.schemeName }}
                    </td>
                </ng-template>
                <ng-template [ngIf]="item.schemeName === null">
                    <td *ngIf="item.bannerType === 'Banners for Product'">
                        NA
                    </td>
                </ng-template>
                    <td
                        *ngIf="item.bannerType !== 'Banners for Product'"
                        [display]="item.name"
                        [tooltip]="item.name"
                        placement="top"
                        show-delay="300"
                    >
                        {{ item.name }}
                    </td>
                    <ng-template [ngIf]="item.clickableUrl !== 'null'">
                        <td
                            *ngIf="item.bannerType === 'Banners for CEO'"
                            [display]="item.clickableUrl"
                            [tooltip]="item.clickableUrl"
                            placement="top"
                            show-delay="300"
                        >
                            {{ item.clickableUrl }}
                        </td>
                    </ng-template>
                    <ng-template [ngIf]="item.clickableUrl === 'null'">
                        <td *ngIf="item.bannerType === 'Banners for CEO'">
                            NA
                        </td>
                    </ng-template>
                    <td class="text-center">{{ item.endDate}}</td>
                    <td class="text-center">
                        <img
                            src="assets/icons/icon_view.png"
                            class="cursor-pointer"
                            (click)="viewFile(item.filePath)"
                        >
                    </td>
                    <td class="text-center">
                        <img
                            src="assets/icons/delete_icon.png"
                            class="cursor-pointer"
                            (click)="deleteFile(item)"
                        >
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="data?.length > pageSize">
                <tr>
                    <td
                        colspan="5"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="data?.length <= 0">No Banners found</div>
    </div>
   
</div>
